import React, { useEffect } from "react";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Modal from "~/components-shared/Modal";
import topicActionCreators from "~/store/topics/actions";
import topicSelectors from "~/store/topics/selectors";
import { Alert, Spinner } from "~/components-shared";
import { TopicActionEnum } from "~/store/topics/types";
import { RoutesEnum, StatusStateEnum, TopicStatusEnum, TopicVisibilityEnum } from "~/types/enums";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
import moment from "moment/moment";
import TopicForm from "~/forms/TopicForm";
import topicSchema from "~/forms/TopicForm/topicSchema";
import authSelectors from "~/store/auth/selectors";
const Sticky = styled.div`
  position: sticky;
  top: 0;
  z-index: 2;
`;
const Form = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  height: 100%;
`;
const TopicCreateFromTemplateModal = () => {
  const {
    t
  } = useTranslation();
  const action = useSelector(topicSelectors.getAction);
  const template = useSelector(topicSelectors.getSelectedData);
  const status = useSelector(topicSelectors.getStatusByTopic("+"));
  const error = useSelector(topicSelectors.getErrorByTopic("+"));
  const user = useSelector(authSelectors.getUser);
  const dispatch = useDispatch();
  const history = useHistory();
  const defaultValues = {
    name: template?.data.name || "",
    status: TopicStatusEnum.ACTIVE,
    description: template?.data.description || "",
    keywords: template?.data.keywords || " ",
    visibility: TopicVisibilityEnum.EVERYONE,
    ownerId: user?.id,
    memberIds: [],
    startDate: moment().toISOString(),
    sources: [],
    trigger: template?.data.trigger || "",
    settings: {},
    markSlackAiDetections: false,
    targets: template?.data.targets.map(_ref => {
      let {
        name,
        description,
        color,
        duration
      } = _ref;
      return {
        name,
        description,
        color,
        duration,
        memberIds: [],
        sources: []
      };
    })
  };
  const {
    handleSubmit,
    control,
    reset,
    setValue,
    watch
  } = useForm({
    resolver: yupResolver(topicSchema),
    defaultValues
  });
  useEffect(() => {
    if (action === TopicActionEnum.CREATE_FROM_TEMPLATE && !!template) {
      reset(defaultValues);
    }
  }, [!!template, action]);
  const onCancel = () => {
    dispatch(topicActionCreators.actionChanged(null, null));
  };
  const handleBack = () => {
    dispatch(topicActionCreators.actionChanged(TopicActionEnum.PICK_TEMPLATE, null));
  };
  const onSubmit = handleSubmit(data => {
    dispatch(topicActionCreators.createStarted(data, _ref2 => {
      let {
        data: newTopic
      } = _ref2;
      if (newTopic) {
        dispatch(toastsActionCreators.pushed({
          severity: "success",
          message: t("TopicCreateFromTemplateModal.topicCreated", {
            name: newTopic.name
          }),
          timeout: 10000,
          actions: [{
            icon: "external-link",
            onClick: () => history.push(RoutesEnum.TOPIC.replace(":topicId", newTopic.id))
          }]
        }));
        reset(defaultValues);
      }
    }));
  });
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("TopicCreateFromTemplateModal.createTopic"),
    onClose: onCancel,
    fullWidth: true,
    maxWidth: "1200px",
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, template ? /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(Sticky, null, /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error)), /*#__PURE__*/React.createElement(TopicForm, {
    control: control,
    watch: watch,
    fromTemplate: true,
    setValue: setValue,
    topic: null
  })) : /*#__PURE__*/React.createElement(Spinner, {
    center: true
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleBack,
    rounded: true
  }, t("TopicCreateFromTemplateModal.backToTemplates")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("TopicCreateModal.saveTopic")))));
};
export default TopicCreateFromTemplateModal;